export default __webpack_public_path__ + "static/media/display.82992176.png";